export const ERP_BRAND = {
  orange: "#F35A3A",
  dark: "#19242F",
  muted: "rgba(25,36,47,0.62)",
  border: "rgba(25,36,47,0.09)",
  soft: "#F7F8FB",
};

export const MOVEMENT_KIND_LABELS = {
  sale: "Venta",
  purchase: "Compra",
  expense: "Gasto",
  internal_consumption: "Consumo interno",
  collection: "Cobranza",
  stock_in: "Entrada de inventario",
  stock_out: "Salida de inventario",
  stock_adjustment: "Ajuste de inventario",
  cash_in: "Ingreso de caja",
  cash_out: "Egreso de caja",
  transfer: "Transferencia",
  payment: "Pago",
  refund: "Devolución",
  opening_balance: "Inventario inicial",
  closing_balance: "Saldo de cierre",
  other: "Otro",
  reversal: "Reversa",
};

export const MOVEMENT_STATUS_LABELS = {
  draft: "Borrador",
  confirmed: "Confirmado",
  voided: "Anulado",
};

export const TRANSACTION_KIND_LABELS = {
  receipt: "Cobro",
  payment: "Pago",
  refund: "Devolución",
  transfer: "Transferencia",
  adjustment: "Ajuste",
  reversal: "Reversa",
};

export const PAYMENT_METHOD_LABELS = {
  cash: "Efectivo",
  bank_transfer: "Transferencia bancaria",
  card: "Tarjeta",
  digital_wallet: "Billetera digital",
  account: "Cuenta corriente",
  check: "Cheque",
  other: "Otro",
};

export const ACCOUNT_TYPE_LABELS = {
  asset: "Activo",
  liability: "Pasivo",
  equity: "Patrimonio",
  income: "Ingreso",
  expense: "Egreso",
};

export function entityId(entity = {}) {
  if (typeof entity === "string" || typeof entity === "number") return String(entity);
  return String(entity?.id || entity?._id || "");
}

export function formatMoney(value, currency = "ARS") {
  const amount = Number(value || 0);
  try {
    return new Intl.NumberFormat("es-AR", {
      style: "currency",
      currency: currency || "ARS",
      maximumFractionDigits: 2,
    }).format(Number.isFinite(amount) ? amount : 0);
  } catch (_error) {
    return `$${(Number.isFinite(amount) ? amount : 0).toLocaleString("es-AR")}`;
  }
}

export function formatDate(value) {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return new Intl.DateTimeFormat("es-AR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }).format(date);
}

export function formatDateTime(value) {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return new Intl.DateTimeFormat("es-AR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(date);
}

export function toLocalDateTimeInput(value = new Date()) {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  const local = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  return local.toISOString().slice(0, 16);
}

export function toDateInput(value = new Date()) {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  const local = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  return local.toISOString().slice(0, 10);
}

export function movementStatusColor(status) {
  if (status === "confirmed") return "success";
  if (status === "voided") return "error";
  return "warning";
}

export function movementKindColor(kind) {
  if (["sale", "collection", "cash_in", "stock_in"].includes(kind)) return "success";
  if (["purchase", "expense", "payment", "cash_out", "stock_out", "internal_consumption"].includes(kind)) return "warning";
  if (kind === "reversal") return "error";
  return "default";
}

export function safeNumber(value) {
  const number = Number(value || 0);
  return Number.isFinite(number) ? number : 0;
}

export function uniqueRequestKey(prefix = "erp") {
  const random = Math.random().toString(36).slice(2, 9);
  return `${prefix}-${Date.now()}-${random}`;
}

export function projectProductName(product = {}) {
  return product.name || product.nombre || "Sin nombre";
}

export function projectProductCode(product = {}) {
  return product.code || product.codigo || "";
}

export function projectProductPrice(product = {}) {
  return safeNumber(product.price ?? product.precio);
}

export function projectProductStock(product = {}) {
  return safeNumber(product.stock);
}

export function projectProductType(product = {}) {
  const value = String(product.itemType || product.type || product.tipo || "product").toLowerCase();
  return ["service", "servicio"].includes(value) ? "service" : "product";
}
